import React from "react";
import { IcGarbageTruck, IcProfile } from "@racoon/icons";
import { Namespace, useT } from "@racoon/i18n";
import { ModeTabs } from "~/shared/ui/mode-tabs";
import { useShiftsView } from "../model/use-shifts-view";

/** Switches the shift registry between its truck and driver views, as the Gantt does. */
export const ShiftsViewToggle: React.FC = () => {
  const t = useT();
  const { view, setView } = useShiftsView();

  return (
    <div role="group" aria-label={t(Namespace.Autopark, "tabs.registry")} className="w-16 shrink-0">
      <ModeTabs
        variant="outline"
        value={view}
        onChange={setView}
        testId="shifts-view"
        options={[
          {
            value: "truck",
            label: t(Namespace.Autopark, "shifts.view.byTruck"),
            icon: <IcGarbageTruck aria-hidden className="h-4 w-4" />,
          },
          {
            value: "driver",
            label: t(Namespace.Autopark, "shifts.view.byDriver"),
            icon: <IcProfile aria-hidden className="h-4 w-4" />,
          },
        ]}
      />
    </div>
  );
};
